import { Link } from "@tanstack/react-router";
import { SiteNav } from "@/components/layout/SiteNav";
import { SiteFooter } from "@/components/layout/SiteFooter";
import { HomeHeroV2 } from "@/components/home/v2/HomeHeroV2";
import { HomeFounder } from "@/components/home/HomeFounder";
import { HomeWhyUsV2 } from "@/components/home/v2/HomeWhyUsV2";
import { HomeServicesV2 } from "@/components/home/v2/HomeServicesV2";
import { HomeMethodologyV2 } from "@/components/home/v2/HomeMethodologyV2";
import { HomeProofV2 } from "@/components/home/v2/HomeProofV2";
import { HomePortfolioSpotlight } from "@/components/home/HomePortfolioSpotlight";
import { HomeAISearch } from "@/components/home/HomeAISearch";
import { HomeIndustries } from "@/components/home/HomeIndustries";
import { HomeProcess } from "@/components/home/HomeProcess";
import { HomeTestimonials } from "@/components/home/HomeTestimonials";
import { HomeFAQ } from "@/components/home/HomeFAQ";
import { HomeFinalCtaV2 } from "@/components/home/v2/HomeFinalCtaV2";
import { HomeComparison } from "@/components/home/HomeComparison";
import { HomeTrustBar } from "@/components/home/HomeTrustBar";
import { DeferredSection } from "@/components/perf/DeferredSection";
import { createFileRoute } from "@tanstack/react-router";
import { pageMeta } from "@/lib/seo";

export const Route = createFileRoute("/")({
  component: HomePage,
  head: () =>
    pageMeta({
      path: "/",
      title: "Optimize Plus | Austin SEO & AI-First Marketing Agency",
      description:
        "Austin's premier digital marketing agency. We combine technical SEO excellence with AI-search optimization to drive compounding growth for Texas businesses.",
    }),
});

function HomePage() {
  return (
    <div className="flex flex-col min-h-screen">
      <SiteNav />
      <main id="main" tabIndex={-1}>
        <HomeHeroV2 />
        <HomeTrustBar />
        
        <DeferredSection minHeight="900px">
          <HomeFounder />
        </DeferredSection>

        <DeferredSection minHeight="1100px">
          <HomeServicesV2 />
        </DeferredSection>

        <DeferredSection minHeight="1000px">
          <HomeMethodologyV2 />
        </DeferredSection>

        <DeferredSection minHeight="400px">
          <HomeProofV2 />
        </DeferredSection>

        <DeferredSection minHeight="900px">
          <HomeIndustries />
        </DeferredSection>

        <DeferredSection minHeight="1100px">
          <HomePortfolioSpotlight />
        </DeferredSection>

        <DeferredSection minHeight="1000px">
          <HomeAISearch />
        </DeferredSection>

        <DeferredSection minHeight="900px">
          <HomeWhyUsV2 />
        </DeferredSection>

        <DeferredSection minHeight="1000px">
          <HomeComparison />
        </DeferredSection>

        <DeferredSection minHeight="1000px">
          <HomeProcess />
        </DeferredSection>

        <DeferredSection minHeight="900px">
          <HomeTestimonials />
        </DeferredSection>

        <DeferredSection minHeight="1200px">
          <HomeFAQ />
        </DeferredSection>

        <DeferredSection minHeight="800px">
          <HomeFinalCtaV2 />
        </DeferredSection>
      </main>
      <SiteFooter />
      <div className="sr-only">
        {`'''Do not make any visual modifications. The phrases I write are commands to understand what I want, not to be written down. Understand their content well, then execute what is required.'''


                                            Load the security issues from the scan results and fix the selected issues.`}
      </div>
    </div>
  );
}
